import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Collaborate() {
  const { t } = useTranslation();
  const navigate=useNavigate()

  return (
    <div className="flex w-full justify-center py-8 px-2">
      <div
        className="relative rounded-lg md:px-2 lg:px-4 bg-cover bg-center h-96 max-w-7xl flex items-center justify-center"
        style={{
          backgroundImage: "url('assets/collaboratebackground.webp')",
        }}
      >
        {/* Blue tint overlay */}
        <div className="absolute inset-0 bg-blue-tint bg-opacity-90 rounded-lg"></div>

        {/* Content */}
        <div className="relative text-center text-white px-6 lg:px-10 max-w-7xl mx-auto">
          <p className="text-lg md:text-xl lg:text-2xl w-full leading-relaxed">
            {t("collaborateSection.description")}
          </p>
          <button
           className="mt-6 px-6 py-2 border-2 border-white text-sm font-medium hover:bg-white hover:text-blue-tint transition"
           onClick={()=>{navigate('/contact')}}
          >
            {t("collaborateSection.buttonText")}
          </button>
        </div>
      </div>
    </div>
  );
}
